module.exports = __webpack_public_path__ + "static/img/sil_done.855b63fe.png";